import Box from 'components/shared/Box'
import Modal from 'components/shared/Modal'
import SinglePhoto from 'components/shared/Gallery/SinglePhoto'

import symulatorImage from 'assets/images/symulator/surfAir.jpg'
import symulatorImageMobile from 'assets/images/symulator/surfAir_mobile.jpg'
import iconFaces from 'assets/icons/faces.svg'
import iconHeight from 'assets/icons/height.svg'

import IconWithText from 'components/shared/IconWithText'
import { FormattedMessage, useIntl } from 'react-intl'
import { useResolutions } from 'store/resolutions'
import { SymulatorModalBody } from './styles'
import { UpsellModalProps } from './types'

const SymulatorModal = ({ isOpened, closeModal }: UpsellModalProps) => {
    const { formatMessage } = useIntl()
    const { isTablet } = useResolutions()

    return (
        <Modal
            isOpened={isOpened}
            maxWidth={670}
            onClose={closeModal}
            isMobileFullscreen
            hasGlobalHeader
            headerMessage={
                <FormattedMessage
                    id="upsells.surfair.title"
                    defaultMessage="Surf Air"
                />
            }
            testIdPrefix="surf-box-about"
        >
            <>
                <SymulatorModalBody
                    pt={[24, 40]}
                    pl={[16, 40]}
                    pr={[16, 40]}
                    pb={40}
                    gap={40}
                >
                    <Box
                        justify="space-between"
                        isFullWidth
                        direction={['column', 'row']}
                        gap={[22, 32]}
                    >
                        <IconWithText
                            icon={iconFaces}
                            iconAlt="smiley faces icon"
                            textHighlighted={formatMessage({
                                id: 'upsells.surfair.modal_instructors_info',
                                defaultMessage:
                                    'Doświadczona ekipa instruktorów',
                            })}
                        />
                        <IconWithText
                            icon={iconHeight}
                            iconAlt="minimal height icon"
                            textHighlighted={formatMessage({
                                id: 'upsells.surfair.modal_limitations_info',
                                defaultMessage:
                                    'Dostępne dla osób powyżej 120 cm wzrostu',
                            })}
                        />
                    </Box>
                    <SinglePhoto
                        photoPath={
                            isTablet ? symulatorImageMobile : symulatorImage
                        }
                        alt="Surf Air symulator"
                    />
                </SymulatorModalBody>
            </>
        </Modal>
    )
}

export default SymulatorModal
